import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { selectAssignedTaskFilter } from "../../../redux/plannerFilterSlice";

export function useAssignedTaskPanelState() {
  const assignedTaskFilter = useSelector(selectAssignedTaskFilter);
  const [filter, setFilter] = useState(assignedTaskFilter || "Mine");
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  return {
    anchorEl,
    filter,
    handleClose,
    handleOpen,
    setFilter,
  };
}
